import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';

export const useFunctionQuery = (breakpoint='sm') => {
  return useMediaQuery((theme) => theme.breakpoints.down(breakpoint));
};

export const withMediaQuery = (query=[]) => (Component) =>
  function Query(props) {
    const mediaProps = {};
    let _key = 'isMobile';
    let _query = (theme) => theme.breakpoints.down('sm');
    if (Array.isArray(query) && query.length == 2) {
      _key = query[0];
      _query = query[1];
    }
    mediaProps[_key] = useMediaQuery(_query);
    return <Component {...mediaProps} {...props} />;
  };
